import { render, staticRenderFns } from "./OnboardingGuide.vue?vue&type=template&id=54058e34&scoped=true"
import script from "./OnboardingGuide.vue?vue&type=script&lang=js"
export * from "./OnboardingGuide.vue?vue&type=script&lang=js"
import style0 from "./OnboardingGuide.vue?vue&type=style&index=0&id=54058e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54058e34",
  null
  
)

export default component.exports